import Header from "./components/Header/Header";
import Body from "./components/Body/Body";
import Modal from "./components/Modal/Modal";
import "./App.scss";
import { useState } from "react";

function App() {
  const [modal, setModal] = useState(true);
  return (
    <div className="App">
      <Header />
      <Body />
      {modal && <Modal modal={modal} setModal={setModal} />}
    </div>
  );
}

export default App;
